module.exports = __webpack_public_path__ + "img/isotype.f7f6a62f.svg";